import { useEffect, useState } from "react";
import { recipeSettingsAPI } from "@/lib/api";
export type RecipeStockSettings = { blockSaleWhenInsufficientStock: boolean; allowNegativeStock: boolean };
const defaults: RecipeStockSettings = { blockSaleWhenInsufficientStock: true, allowNegativeStock: false };

export function useRecipeStockSettings(enabled: boolean) {
	const [draft, setDraft] = useState(defaults);
	const [saved, setSaved] = useState(defaults);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [revision, setRevision] = useState(0);
	useEffect(() => {
		if (!enabled) return;
		let cancelled = false;
		setLoading(true);
		setError(false);
		recipeSettingsAPI
			.get()
			.then(data => {
				if (cancelled) return;
				const value = {
					blockSaleWhenInsufficientStock: data?.blockSaleWhenInsufficientStock !== false,
					allowNegativeStock: data?.allowNegativeStock === true,
				};
				setDraft(value);
				setSaved(value);
			})
			.catch(() => {
				if (!cancelled) setError(true);
			})
			.finally(() => {
				if (!cancelled) setLoading(false);
			});
		return () => {
			cancelled = true;
		};
	}, [enabled, revision]);
	const dirty =
		enabled &&
		!loading &&
		!error &&
		(draft.blockSaleWhenInsufficientStock !== saved.blockSaleWhenInsufficientStock ||
			draft.allowNegativeStock !== saved.allowNegativeStock);
	return {
		draft,
		setDraft,
		loading,
		error,
		dirty,
		retry: () => setRevision(value => value + 1),
		markSaved: () => setSaved(draft),
		save: async () => {
			if (!dirty) return;
			await recipeSettingsAPI.update(draft);
			setSaved(draft);
		},
	};
}
